import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadCustomization } from "../state/actions/loadCustomization";
import { CustomizationsState, CustomizationState } from "../types";

export const useCustomization = <T>(selector: F1<CustomizationState, T>, params?: { loadCustomization: boolean }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (params?.loadCustomization !== false) {
            dispatch(loadCustomization());
        }
    }, []);

    const customization = useSelector((state: CustomizationsState) => state.customization);
    return selector(customization);
};
